import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { SectionReveal } from './SectionReveal';
const faqs = [{
  q: '¿Necesito conocimientos previos?',
  a: 'No. Está diseñado para principiantes absolutos.'
}, {
  q: '¿Es un curso con videos?',
  a: 'No. Todo el contenido se entrega en PDF.'
}, {
  q: '¿Cuándo recibo el material?',
  a: 'Inmediatamente después del pago.'
}, {
  q: '¿Puedo verlo desde el celular?',
  a: 'Sí. Funciona perfectamente en celular, tablet y computadora.'
}, {
  q: '¿Los bonos están incluidos?',
  a: 'Sí. Los 6 bonos están incluidos sin costo adicional.'
}, {
  q: '¿Sirve para cualquier vehículo?',
  a: 'Sí. Los conceptos aplican a la mayoría de los automóviles.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 md:py-32 bg-[#171717] border-b border-[#262626]" data-id="element-58">
      <div className="max-w-3xl mx-auto px-4 md:px-6" data-id="element-59">
        <SectionReveal className="text-center mb-16" data-id="element-60">
          <h2 className="text-3xl md:text-5xl font-bold text-white" data-id="element-61">
            Preguntas Frecuentes
          </h2>
        </SectionReveal>

        <SectionReveal delay={0.2} className="space-y-4" data-id="element-62">
          {faqs.map((faq, idx) => <div key={idx} className="bg-[#0a0a0a] border border-[#262626] rounded-sm overflow-hidden" data-id="element-63">
              <button onClick={() => toggleFaq(idx)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={openIndex === idx} data-id="element-64">
                <span className="text-lg font-medium text-white" data-id="element-65">{faq.q}</span>
                <motion.div animate={{
              rotate: openIndex === idx ? 180 : 0
            }} transition={{
              duration: 0.3
            }} data-id="element-66">
                  <ChevronDown className="w-5 h-5 text-[#F59E0B]" data-id="element-67" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-68">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-69">
                    <div className="px-6 pb-5 text-[#9CA3AF]" data-id="element-70">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </SectionReveal>
      </div>
    </section>;
}